<template>
    <div
        class="block-ellipsis"
        ref="block">
        <slot></slot>
    </div>
</template>

<script>
    import ClampJs from 'clamp-js';

    // TODO:
    //
    // This is used for truncating multiple lines of text with an ellipsis. It's
    // used on the KB Category page. However, I tried using it elsewhere and it
    // just straight up didn't work...
    //
    // We need some usage docs for this, and may need to replace ClampJS (seems
    // like a dead project on Github).

    export default {
        mounted() {
            ClampJs(this.$refs.block);
        },
    }
</script>



// WEBPACK FOOTER //
// index.vue?2a99e214